import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import { useTranslation } from 'react-i18next';
import { LoginForm } from '../LoginForm/LoginForm';
import { ResetForm } from '../ResetForm/ResetForm';
import { SignupForm } from '../SignupForm/SignupForm';

const AUTH_MODE = { LOGIN: 'login', RESET: 'reset', SIGNUP: 'signup' };

// Mode is owned by App (so the /signup deep link can open the dialog in signup mode).
const AuthDialog = ({
    open,
    mode = AUTH_MODE.LOGIN,
    prefillEmail,
    onClose,
    onModeChange = () => {},
    setUser,
    notifications,
}) => {
    const { t } = useTranslation();

    const handleOnClose = (event, reason) => {
        if (reason === 'backdropClick') {
            return;
        }
        onClose();
    };

    const titleKey = { login: 'loginForm.title', reset: 'resetForm.title', signup: 'signupForm.title' }[mode];

    return (
        <Dialog fullWidth={true} maxWidth={'xs'} open={open} onClose={handleOnClose}>
            <DialogTitle>{t(titleKey)}</DialogTitle>
            <DialogContent>
                {mode === AUTH_MODE.LOGIN && (
                    <LoginForm
                        setUser={setUser}
                        onCancel={onClose}
                        notifications={notifications}
                        onReset={() => onModeChange(AUTH_MODE.RESET)}
                        onSignup={() => onModeChange(AUTH_MODE.SIGNUP)}
                    />
                )}
                {mode === AUTH_MODE.RESET && <ResetForm onCancel={onClose} notifications={notifications} />}
                {mode === AUTH_MODE.SIGNUP && (
                    <SignupForm
                        onCancel={onClose}
                        onLogin={() => onModeChange(AUTH_MODE.LOGIN)}
                        notifications={notifications}
                        prefillEmail={prefillEmail}
                    />
                )}
            </DialogContent>
        </Dialog>
    );
};

export { AuthDialog, AUTH_MODE };
